"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.placeholderColor = exports.inputColor = exports.borderColor = void 0;
var _color = _interopRequireDefault(require("webmotors-react-pj/tokens/color"));
const borderColor = _ref => {
  let {
    error,
    focus
  } = _ref;
  if (error) {
    return (0, _color.default)('error');
  }
  return focus ? (0, _color.default)('gray') : (0, _color.default)('gray-4');
};
exports.borderColor = borderColor;
const placeholderColor = _ref2 => {
  let {
    error,
    focus
  } = _ref2;
  if (error) {
    return (0, _color.default)('error');
  }
  return focus ? (0, _color.default)('gray') : (0, _color.default)('gray-3');
};
exports.placeholderColor = placeholderColor;
const inputColor = _ref3 => {
  let {
    error,
    active
  } = _ref3;
  if (error) {
    return (0, _color.default)('error');
  }
  return active ? (0, _color.default)('gray') : (0, _color.default)('gray-3');
};
exports.inputColor = inputColor;